import { getAxiosClient } from "../../axios-client";
import { UpdateAvailabilityBody, UpdateAvailabilityResponse } from "./types";

const axiosClient = getAxiosClient();
export const updateAvailability = async (body: UpdateAvailabilityBody) => {
    return await axiosClient.ax.put<UpdateAvailabilityResponse>("/Availability/Update", body);
};
